import { fromJS } from 'immutable';
import { YES_BANK_CARD_RENEWAL_MANAGEMENT_OTP_SUCCESS, DEFAULT_ACTION } from './constants';


const initialState = fromJS({
  isLoading: false,
  yesBankRenewalManagementOtpSuccess: {},
});

function yesBankRenewalManagementReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case DEFAULT_ACTION:
      return state
        .set('isLoading', payload);
    case YES_BANK_CARD_RENEWAL_MANAGEMENT_OTP_SUCCESS:
      return state
        .set('yesBankRenewalManagementOtpSuccess', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default yesBankRenewalManagementReducer;



// WEBPACK FOOTER //
// client/containers/YesBankRenewalManagement/reducer.js